var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.52024 18.7598V8.83984H3.44023C1.68023 8.83984 0.240234 10.2798 0.240234 12.0398V21.6398C0.240234 23.3998 1.68023 24.8398 3.44023 24.8398H5.04023V29.6398L9.84023 24.8398H17.8402C19.6002 24.8398 21.0402 23.3998 21.0402 21.6398V18.7278C20.9351 18.7504 20.8278 18.7617 20.7202 18.7614H9.52024V18.7598ZM29.0402 0.839844H14.6402C12.8802 0.839844 11.4402 2.27984 11.4402 4.03984V16.8398H22.6402L27.4402 21.6398V16.8398H29.0402C30.8002 16.8398 32.2402 15.4014 32.2402 13.6398V4.03984C32.2402 2.27984 30.8002 0.839844 29.0402 0.839844Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.87107aadba4ce05521e4f922248908de.svg";
export { ForwardRef as ReactComponent };